import React, { useState } from "react";
import { InteractiveTooltipWrapper } from "schedule-v2/components";
import withComponentLibraryTheme from "hocs/withComponentLibraryTheme";
import { Tabs } from "@my-scoot/component-library-legacy";
import ExlyTabsWrapper from "common/Components/ExlyTabsWrapper";
import ManageRecordingsTable from "./ManageRecordingsTable";
import { ManageRecordingsListTable } from "./components/ManageRecordingsListTable/ManageRecordingsListTable";
import useFeatureOnboardingChecker from "common/Components/FeatureOnboarding/useFeatureOnboardingChecker";
import useManageRecordings from "./hooks/useManageRecordings";
import {
  manage_recordings_onboarding_keys,
  RECORDING_TAB_OPTIONS,
  RECORDING_TABS,
} from "./constants/ManageRecordings.constant";

const ManageRecordings = (props) => {
  const [activeTab, setActiveTab] = useState(
    RECORDING_TABS.UNMAPPED_RECORDINGS
  );

  const {
    listingUuid,
    parentOffering = {},
    showViewRecordingModal,
    viewRecordingModalData,
    handleToggleShowViewRecordingModal,
    handleViewRecordingActionClick,
    recordToSelectedSection,
    handleSelectedSectionMappingChange,
    courseSectionOptions,
    setCourseSectionOptions,
    showSectionChangesModal,
    toggleShowSaveSectionChangesModal,
    handleSaveChnagesClick,
    batchesProps,
    sessionsProps,
    customersProps,
    isPageDataLoaing,
    rcListingUuid,
    getZoomRcOfferingDetails,
    handleClearMappingStates,
  } = useManageRecordings();

  const { isOnboarded, flagLoading, handleFeatureOnboardChange } =
    useFeatureOnboardingChecker({
      featureKey: manage_recordings_onboarding_keys[parentOffering.type],
    });

  const handleTooltipClose = () => {
    handleFeatureOnboardChange(true);
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const recordingProps = {
    listingUuid,
    rcListingUuid,
    parentOffering,
    showViewRecordingModal,
    viewRecordingModalData,
    handleToggleShowViewRecordingModal,
    handleViewRecordingActionClick,
    recordToSelectedSection,
    handleSelectedSectionMappingChange,
    courseSectionOptions,
    setCourseSectionOptions,
    showSectionChangesModal,
    toggleShowSaveSectionChangesModal,
    handleSaveChnagesClick,
    batchesProps,
    sessionsProps,
    customersProps,
    isPageDataLoaing,
    getZoomRcOfferingDetails,
    handleClearMappingStates,
  };

  return (
    <div id="mainLayout">
      <div className="tw-mt-6 tw-ml-4 md:tw-ml-6">
        <ExlyTabsWrapper>
          <Tabs
            tabs={RECORDING_TAB_OPTIONS}
            value={activeTab}
            onChange={handleTabChange}
            tabVariant="outlined"
          />
        </ExlyTabsWrapper>
      </div>
      <InteractiveTooltipWrapper onClose={handleTooltipClose}>
        {activeTab === RECORDING_TABS.UNMAPPED_RECORDINGS && (
          <ManageRecordingsTable
            tableProps={props}
            isOnboarded={isOnboarded}
            flagLoading={flagLoading}
            recordingProps={recordingProps}
          />
        )}
        {activeTab === RECORDING_TABS.MANAGE_RECORDINGS && (
          <ManageRecordingsListTable
            tableProps={props}
            recordingProps={recordingProps}
          />
        )}
      </InteractiveTooltipWrapper>
    </div>
  );
};

export default withComponentLibraryTheme(ManageRecordings);
